<gio-color-view [color]="color" [ngClass]="{pointer: !disabled}" (click)="colorClicked()"></gio-color-view>

<div *ngIf="showPicker" class="picker" [ngStyle]="styles.picker">
  <gio-color-picker-card
    [color]="color"
    [options]="options"
    (colorChanged)="colorChangedOnPicker($event)"
    (colorSelected)="showPicker = false">
</gio-color-picker-card>
</div>
